import {
    selectedRecordsField,
    updatedRecordsField,
} from 'app/shared-components/SimpleBulkUpload/SimpleBulkUpload.utils'
import {
    FeedbackFormFields,
    UpdateFormFields,
} from 'app/shared-components/SimpleBulkUpload/SimpleBulkUpload.types'

import {
    LaneFeesFilterRequestResponse,
} from '../LaneFees.types'

export const updateFormFields: UpdateFormFields<LaneFeesFilterRequestResponse> = [{
    title: '',
    fields: [
        selectedRecordsField,
        {
            name: 'validTo',
            labelKey: 'LaneFees.validTo',
            componentName: 'DateSelect',
            required: true,
        },
    ],
}]

export const feedbackFormFields: FeedbackFormFields<LaneFeesFilterRequestResponse> = [{
    title: '',
    fields: [
        selectedRecordsField,
        updatedRecordsField,
        {
            name: 'validTo',
            labelKey: 'LaneFees.validTo',
            componentName: 'InputSingleline',
            disabled: true,
        },
    ],
}]
